<template>
  <div
    class="d-flex flex-column align-center justify-center text-center px-6"
    style="flex: 1; overflow-y: auto;"
  >
    <!-- Arrow pointing up toward the study dataset switcher -->
    <v-icon color="primary" size="36">mdi-arrow-up</v-icon>
    <div class="primary--text font-weight-medium mt-2 subtitle-1">
      Select a study dataset above
    </div>
    <div class="grey--text mt-1 body-2" style="max-width: 320px;">
      Only
      <v-tooltip bottom max-width="280" color="primary">
        <template v-slot:activator="{ on }">
          <span class="shared-word" v-on="on">shared</span>
        </template>
        <span
          >A study dataset is “shared” when its owner gives other users access
          to it. Shared datasets — ones you own and shared, or that others
          shared with you — are the only ones that appear in Team Chat.</span
        >
      </v-tooltip>
      study datasets can be opened in Team Chat.
    </div>

    <!-- Tour invitation -->
    <v-btn color="primary" outlined class="mt-5" @click="$emit('take-tour')">
      <v-icon left small>mdi-compass-outline</v-icon>
      Take a tour
    </v-btn>
    <div class="grey--text body-2 mt-2" style="max-width: 280px;">
      New here? Take a quick guided tour of how Team Chat works.
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatEmptyState',
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.shared-word {
  text-decoration: underline dotted;
  text-underline-offset: 2px;
  cursor: help;
  font-weight: 600;
}
</style>
